__turbopack_context__.v({
  "drawer": "iT6NHa_drawer",
  "empty": "iT6NHa_empty",
  "list": "iT6NHa_list",
  "listInner": "iT6NHa_listInner",
});
